import styled from '@emotion/styled';
import { InputTextarea } from 'primereact/inputtextarea';

// The backdrop only lines up with the textarea while every one of these metrics is identical on both.
const sharedTextMetrics = `
    box-sizing: border-box;
    margin: 0;
    padding: 10px 12px;
    border-width: 1px;
    border-style: solid;
    font-family: inherit;
    font-size: 14px;
    line-height: 1.5;
    letter-spacing: normal;
    white-space: pre-wrap;
    overflow-wrap: break-word;
    word-break: normal;
`;

export const PlaceholderEditor = styled.div`
    position: relative;
    display: flex;
    background: #fff;
    border-radius: 6px;
`;

export const PlaceholderBackdrop = styled.div`
    ${sharedTextMetrics}
    position: absolute;
    inset: 0;
    overflow: hidden;
    border-color: transparent;
    color: transparent;
    pointer-events: none;
`;

export const PlaceholderHighlight = styled.mark`
    color: transparent;
    background: #fde68a;
    border-radius: 3px;
`;

// Doubled class beats PrimeReact's theme, which otherwise sets its own padding, font, and opaque background.
export const PlaceholderInput = styled(InputTextarea)`
    && {
        ${sharedTextMetrics}
        position: relative;
        width: 100%;
        background: transparent;
    }
`;
